unit NetNumberItemType;
{

/* Initial. */

}
interface

uses
  JS,
  NetNumberStatusItemType;

type
  TNetNumberItemType = class
  private
    fNetNumberKey: String;
    fNumber: String;
    fNetNumberStatusItem: TNetNumberStatusItemType;
    fActive: Boolean;
  public
    property NetNumberKey: String read fNetNumberKey;
    property Number: String read fNumber;
    property NetNumberStatusItem: TNetNumberStatusItemType read fNetNumberStatusItem;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TNetNumberItemType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fNetNumberKey := String(JSObject_Type['netNumberKey']);
    fNumber := String(JSObject_Type['number']);
    fNetNumberStatusItem := TNetNumberStatusItemType.Create(TJSJSON.stringify(JSObject_Type['netNumberStatusItem']));
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
